import { defineComponent } from 'vue';
export default defineComponent({
    name: 'PfTableColumn',
    slots: ['title', 'filterIcon'],
    render() {
        return null;
    },
});
